import type { Theme } from '@mui/material';

export const styles = {
  barWrapper: (selectable: boolean, selected: boolean) => (theme: Theme) => ({
    p: 1,
    cursor: selectable ? 'pointer' : 'default',
    backgroundColor: selected ? theme.colors.neutral[200] : 'transparent',

    '&:hover': selectable
      ? {
          backgroundColor: theme.colors.neutral[200],
        }
      : {},
  }),

  label: {
    flexGrow: 0,
    width: '40%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  bar: (theme: Theme) => ({
    backgroundColor: theme.colors.secondary[500],
    height: '100%',
  }),

  counter: {
    minWidth: '2rem',
    flexGrow: 0,
    textAlign: 'right',
  },
};
